<template>
	<div class="expert-score">
		<div class="container-fluid">
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row mb-1">
							<div class="col-xl-6">文章发布</div>
							<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="mb-2">
									<el-cascader
										:options="columnOptions"
										:props="{ expandTrigger: 'hover', label: 'name', value: 'id' }"
										clearable
										filterable
										placeholder="请选择所属栏目"
										@change="cascaderChange"
									>
										<template slot-scope="{ node, data }">
											<span>{{ data.name }}</span>
											<span v-if="!node.isLeaf">({{ data.children.length }})</span>
										</template>
									</el-cascader>
									<el-input v-model="query.name" placeholder="请输入文章名称" class="ml-3 mr-3" style="width: 180px"></el-input>
									<el-button type="success" @click="searchData">查询</el-button>
									<el-button type="primary" icon="el-icon-edit" style="font-size:17px" @click="toUpdate(false, 'add')">新增文章</el-button>
								</div>
								<el-table
									:header-cell-style="tableHeaderStyle"
									ref="multipleTable"
									:data="list"
									tooltip-effect="dark"
									style="width: 100%"
									border
									@selection-change="handleSelectionChange"
								>
									<el-table-column type="selection" width="55"></el-table-column>
									<el-table-column label="标题" min-width="200" align="left">
										<template slot-scope="scope">
											<p class="article-title" @click="goArticleDetail(scope.row.id)">{{ scope.row.title }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="userName" label="发布人" min-width="60"></el-table-column>
									<!--  show-overflow-tooltip  -->
									<el-table-column prop="columnName" label="所属栏目" min-width="60">
										<template slot-scope="scope">
											<template v-if="scope.row.parentColumnName">
												{{ scope.row.parentColumnName + ' 》 ' }}
											</template>
											{{ scope.row.columnName }}
										</template>
									</el-table-column>
									<el-table-column prop="seeNum" label="查看次数" min-width="50">
										<template slot-scope="scope">
											{{ scope.row.seeNum ? scope.row.seeNum : '0' }}
										</template>
									</el-table-column>
									<el-table-column prop="localDateTime" label="发布日期" min-width="60">
										<template slot-scope="scope">
											{{ scope.row.localDateTime ? scope.row.localDateTime.substring(0, 10) : '' }}
										</template>
									</el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button v-if="!scope.row.important" type="success" size="small" @click="toUpdate(scope.row, 'important')">设为重要通知</el-button>
											<el-button v-else type="danger" size="small" @click="toUpdate(scope.row, 'important')">取消重要通知</el-button>
											<!-- <el-button type="primary" size="small" style="margin-right: 10px" @click="toUpdate(scope.row,'update')">修改</el-button> -->
											<!-- <el-popconfirm title="确定删除吗？" @confirm="toUpdate(scope.row, 'del')">
                        <el-button type="danger" size="small" slot="reference">删除</el-button>
                      </el-popconfirm> -->
										</template>
									</el-table-column>
								</el-table>
								<div class="mt-2">
									<el-button class="mr-1" @click="handleMoving">移动到...</el-button>
									<el-button class="mr-1" type="primary" @click="toUpdate(false, 'update')">修改</el-button>
									<el-popconfirm title="确定删除吗？" @confirm="toUpdate(false, 'del')"><el-button class="mr-1" type="danger" slot="reference">删除</el-button></el-popconfirm>
								</div>
								<!-- 分页器 -->
								<div class="text-right mt-2">
									<el-pagination background layout="total, prev, pager, next" :page-size="query.pageSize" :total="total" @current-change="handlePageChange"></el-pagination>
								</div>
								<el-dialog width="70%" :title="isAdd ? '添加文章' : '修改文章'" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :before-close="dialogCloseBefore">
									<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="right">
										<el-form-item label="栏目：" prop="columnId">
											<el-cascader
												v-model="cascaderModel"
												:options="columnOptions"
												:props="{ expandTrigger: 'hover', label: 'name', value: 'id' }"
												clearable
												filterable
												@change="
													e => {
														cascaderChange(e, 'form');
													}
												"
											>
												<template slot-scope="{ node, data }">
													<span>{{ data.name }}</span>
													<span v-if="!node.isLeaf">({{ data.children.length }})</span>
												</template>
											</el-cascader>
										</el-form-item>
										<el-form-item label="标题：" prop="title"><el-input v-model="ruleForm.title"></el-input></el-form-item>
										<el-form-item label="内容：">
											<tinymce-editor @input="e => changeData('content', e)" :value="ruleForm.content" :maxLength="20000" :baseUrl="uploadUrl"></tinymce-editor>
										</el-form-item>
										<el-form-item label="附件">
											<upload-file-more @file-event="e => changeData('eduAnnexes', e)" :filelist="ruleForm.eduAnnexes && ruleForm.eduAnnexes[0] ? ruleForm.eduAnnexes : []" />
										</el-form-item>
										<el-form-item label="缩略图："><upLoad-img-one @img-event="e => changeData('thumbnailImage', e)" :value="ruleForm.thumbnailImage" /></el-form-item>
										<el-form-item class="flex_end_x">
											<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
											<el-button @click="dialogFormVisible = false">返回</el-button>
										</el-form-item>
									</el-form>
								</el-dialog>
								<el-dialog width="500px" title="移动到..." :close-on-click-modal="false" :visible.sync="movingVisible">
									<el-form :model="movingQuery" :rules="rules" ref="movingRuleForm" label-width="120px" class="demo-ruleForm" label-position="right">
										<el-form-item label="栏目：" prop="columnId">
											<el-cascader
												v-model="cascaderModel"
												:options="columnOptions"
												:props="{ expandTrigger: 'hover', label: 'name', value: 'id' }"
												clearable
												filterable
												@change="
													e => {
														cascaderChange(e, 'moving');
													}
												"
											>
												<template slot-scope="{ node, data }">
													<span>{{ data.name }}</span>
													<span v-if="!node.isLeaf">({{ data.children.length }})</span>
												</template>
											</el-cascader>
										</el-form-item>
										<el-form-item class="flex_end_x">
											<el-button type="primary" @click="movingSubmitForm('movingRuleForm')">保存</el-button>
											<el-button @click="movingVisible = false">返回</el-button>
										</el-form-item>
									</el-form>
								</el-dialog>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getArticleList, getArticleDetail, deleteArticle, addArticle, updateArticle, updateArticleColumn, getArticleTree } from '@/api/after/systemManagement';
import UpLoadImgOne from '@/components/upLoad/UpLoadImgOne';
import UploadFileMore from '@/components/upLoad/UploadFileMore';
import TinymceEditor from '@/components/TinymceEditor';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	name: 'articleManagement',
	components: {
		UpLoadImgOne,
		UploadFileMore,
		TinymceEditor,
		Breadcrumb
	},
	data() {
		return {
			tableHeaderStyle: {
				backgroundColor: '#3083c5',
				color: '#fff'
			},
			cascaderModel: [],
			dialogFormVisible: false,
			movingVisible: false, //移动栏目
			movingQuery: { columnId: null, ids: [] },
			list: [],
			multipleSelection: [],
			columnOptions: [],
			columnVal: null,
			searchInput: '',
			query: {
				id: 0,
				name: '',
				pageNumber: 1,
				pageSize: 10,
				pageSorts: [{ asc: false, column: '' }]
			},
			total: 0,
			ruleForm: {},
			rules: {
				columnId: [
					{ required: true, message: '请选择所属栏目', trigger: 'blur' },
					{
						pattern: /^[0]*[1-9]+[0]*$/,
						message: '请选择所属栏目',
						trigger: 'blur'
					}
				],
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
			},
			msg: '',
			disabled: false,
			isAdd: true ,//是否添加状态
			timer:null,//定时器
		};
	},
	mounted() {
		this.getData();
		this.getArticleTree();
	},
	methods: {
		// 获取数据列表
		getData() {
			getArticleList(this.query).then(res => {
				if (res.code == 200) {
					this.list = res.data.records;
					this.total = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 获取详情信息
		getDetail(id) {
			getArticleDetail(id).then(res => {
				if (res.code == 200) {
					this.ruleForm = res.data;
					this.cascaderModel = res.data.parentIds;
					console.log(this.cascaderModel);
					this.dialogFormVisible = true;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 获取栏目列表
		getArticleTree() {
			getArticleTree().then(res => {
				if (res.code == 200) {
					this.columnOptions = res.data;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 搜索
		searchData() {
			this.query.pageNumber = 1;
			this.getData();
		},
		//栏目查询
		cascaderChange(e, name) {
			let num = 0;
			e && e.length <= 0 ? (num = 0) : (num = e[e.length - 1]);
			if (name == 'form') {
				this.ruleForm.columnId = num;
			} else if (name == 'moving') {
				this.movingQuery.columnId = num;
			} else {
				this.query.id = num;
			}
		},
		// 修改文章
		toUpdate(data, name) {
			this.cascaderModel = [];
			if (name == 'del') {
				let query = { longs: [] };
				if (data) {
					query.longs = [data.id];
				} else {
					if (this.multipleSelection && this.multipleSelection.length > 0) {
						query.longs = this.multipleSelection.map(item => {
							return item.id;
						});
					} else {
						this.$message('没有选择数据');
						return;
					}
				}
				this.deleteData(query);
			} else if (name == 'update') {
				if (this.multipleSelection.length === 0) {
					this.$message.error('请选择要修改的文章!');
					return;
				} else if (this.multipleSelection.length > 1) {
					this.$message.error('修改时只能单选！');
					return;
				}
				let id = this.multipleSelection[0].id;
				this.isAdd = false;
				this.getDetail(id);
			} else if (name == 'add') {
				this.isAdd = true;
				this.ruleForm = {
					title: '',
					columnId: 0,
					digest: '',
					content: '',
					annexList: null,
					thumbnailImage: ''
				};
				this.dialogFormVisible = true;
			} else if (name == 'important') {
				if (data.important) {
					this.ruleForm = { id: data.id, important: 0 };
				} else {
					this.ruleForm = { id: data.id, important: 1 };
				}
				this.updateData();
			}
		},
		// 参数格式化
		ruleFormChange() {
			// 获取摘要
			let reg = /<\/?.+?\/?>/g;
			let text = '';
			if (this.ruleForm.content) {
				text = this.ruleForm.content.replace(reg, '').replace(/&nbsp;/gi, '');
			}
			this.ruleForm.digest = text.substring(0, 100);
			// 附件列表
			if (this.ruleForm.eduAnnexes && this.ruleForm.eduAnnexes.length > 0 && this.ruleForm.eduAnnexes[0]) {
				let annexList = this.ruleForm.eduAnnexes.map(item => {
					return item.id;
				});
				this.ruleForm.annexList = annexList.join(',');
			} else {
				this.ruleForm.annexList = null;
			}

			delete this.ruleForm.eduAnnexes;
		},
		submitForm(formName) {
			if (this.timer) {
				clearTimeout(this.timer)
			}
			this.timer = setTimeout(()=>{
				this.$refs[formName].validate(valid => {
					if (valid) {
						console.log(this.ruleForm);
						this.ruleFormChange();
						this.isAdd ? this.addData() : this.updateData();
						this.dialogFormVisible = false;
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},1000)
		},
		// 表格项被选中
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 删除
		deleteData(query) {
			deleteArticle(query).then(res => {
				if (res.code == 200) {
					this.$message.success('删除成功');
				} else {
					this.$message.error(res.data);
				}
				this.getData();
			});
		},
		// 添加
		addData() {
			addArticle(this.ruleForm).then(res => {
				if (res.code == 200) {
					this.$message.success('添加成功');
				} else {
					this.$message.error(res.data);
				}
				// this.dialogFormVisible = false;
				this.getData();
			});
		},
		//修改
		updateData() {
			updateArticle(this.ruleForm).then(res => {
				if (res.code == 200) {
					this.$message.success('修改成功');
				} else {
					this.$message.error(res.data);
				}
				// this.dialogFormVisible = false;
				this.getData();
			});
		},
		// 移动文章栏目
		handleMoving() {
			if (this.multipleSelection && this.multipleSelection.length > 0) {
				this.movingQuery.ids = this.multipleSelection.map(item => {
					return item.id;
				});
			} else {
				this.$message('没有选择数据');
				return;
			}
			this.movingVisible = true;
		},
		movingSubmitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.updateArticleColumn();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		//移动
		updateArticleColumn() {
			console.log(this.movingQuery);
			updateArticleColumn(this.movingQuery).then(res => {
				if (res.code == 200) {
					this.$message.success('修改成功');
				} else {
					this.$message.error(res.data);
				}
				this.movingVisible = false;
				this.movingQuery = { columnId: null, ids: [] };
				this.getData();
			});
		},
		changeData(name, data) {
			this.ruleForm[name] = data;
		},
		// 分页导航
		handlePageChange(val) {
			this.query.pageNumber = val;
			this.getData();
		},
		// 跳转到前台商品详情页
		goArticleDetail(id) {
			// this.$router.push(`/publicDetails/${id}`)
			let routeUrl = this.$router.resolve({
				path: `/publicDetails/${id}`
			});
			window.open(routeUrl.href, '_blank');
		},
		// 关闭dialog时触发
		dialogCloseBefore(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		}
	}
};
</script>

<style scoped>
.article-title {
	cursor: pointer;
}
.flex_end_x {
	display: flex;
	justify-content: flex-end;
}
.file_box {
	position: relative;
	display: flex;
	align-items: center;
	border: 1px dashed #d9d9d9;
	height: 30px;
	padding: 0 20px;
	cursor: pointer;
	max-width: calc(100% - 150px);
	margin: 5px 0;
}
.file_box p {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 450px;
	margin-bottom: 0;
	line-height: normal;
}
.close_btn {
	position: absolute;
	top: -8px;
	right: -8px;
}
.wrap {
	background: #fafbfe;
	padding: 30px;
}
.con {
	min-height: 500px;
	background: #fff;
	padding: 30px;
	border-radius: 5px;
}
/deep/.el-table th > .cell {
	text-align: center;
}

/* /deep/.el-table .cell {
  text-align: center;
} */
</style>
